import React, { Component } from "react";
import { Consume } from "../../Context/Consumer";
import { ConstraintsContext } from "../../Context";
import config from "../../common/config";

class PlayerImage extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let self = this;
    let { playerId, teamId, ConstraintsData, removePointer } = self.props;

    return (
      <div
        className="si-plyrSel__thumb"
        style={removePointer ? { pointerEvents: "none" } : {}}
      >
        <div className="si-plyrSel__svg">
          <svg
            width="333"
            height="400"
            viewBox="0 0 333 400"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            xmlSpace="preserve"
          >
            <defs>
              <mask id={`si-${playerId}`}>
                <path
                  className="si-shield--thumb"
                  xlinkHref={`https://omo.akamai.opta.net/image.php?h=omo.akamai.opta.net&sport=football&entity=player&description=${teamId}&dimensions=103x155&id=${playerId}`}
                  d="M165.296 390.849C165.609 390.982 165.945 391.051 166.285 391.051C166.625 391.051 166.961 390.982 167.274 390.849L167.543 390.759C194.766 377.812 220.733 362.375 245.113 344.647C267.764 328.017 285.83 311.029 298.863 294.22C315.312 272.916 323.671 251.793 323.671 231.388V58.8038C323.688 58.2221 323.511 57.6513 323.17 57.18C322.829 56.7086 322.341 56.3631 321.784 56.1971V56.1971L167.004 9.10494C166.542 8.92531 166.029 8.92531 165.566 9.10494L10.8763 56.1971C10.3087 56.3492 9.81097 56.6925 9.46709 57.169C9.12321 57.6456 8.95427 58.2262 8.98878 58.8128V231.397C8.98878 251.811 17.348 272.934 33.7967 294.229C46.7399 311.038 64.8065 327.936 87.4572 344.656C111.904 362.453 137.964 377.921 165.296 390.858V390.849Z"
                ></path>
              </mask>
            </defs>
            <path
              className="si-shield--front"
              d="M165.296 390.849C165.609 390.982 165.945 391.051 166.285 391.051C166.625 391.051 166.961 390.982 167.274 390.849L167.543 390.759C194.766 377.812 220.733 362.375 245.113 344.647C267.764 328.017 285.83 311.029 298.863 294.22C315.312 272.916 323.671 251.793 323.671 231.388V58.8038C323.688 58.2221 323.511 57.6513 323.17 57.18C322.829 56.7086 322.341 56.3631 321.784 56.1971V56.1971L167.004 9.10494C166.542 8.92531 166.029 8.92531 165.566 9.10494L10.8763 56.1971C10.3087 56.3492 9.81097 56.6925 9.46709 57.169C9.12321 57.6456 8.95427 58.2262 8.98878 58.8128V231.397C8.98878 251.811 17.348 272.934 33.7967 294.229C46.7399 311.038 64.8065 327.936 87.4572 344.656C111.904 362.453 137.964 377.921 165.296 390.858V390.849Z"
            ></path>
            <image
              className="clip-path-img"
              mask={`url(#si-${playerId})`}
              xlinkHref={`https://omo.akamai.opta.net/image.php?h=omo.akamai.opta.net&sport=football&entity=player&description=${teamId}&dimensions=103x155&id=${playerId}`}
              transform="translate(0,0)"
              width="333px"
              height="400px"
              preserveAspectRatio="xMinYMin slice"
            ></image>
            <path
              className="si-shield--back"
              d="M166.285 400.002C164.647 399.991 163.028 399.655 161.521 399.013H161.431C133.574 385.805 107.004 370.036 82.0639 351.912C58.6941 334.744 40.0882 317.216 26.5158 299.777C8.98852 276.784 0.000158685 253.863 0.000158685 231.391V58.8065C-0.0129342 56.2934 0.784493 53.843 2.27411 51.819C3.76373 49.795 5.86617 48.3051 8.26945 47.5705L162.959 0.469413C165.133 -0.150612 167.437 -0.150612 169.611 0.469413L324.3 47.5795C326.703 48.3141 328.806 49.804 330.296 51.828C331.785 53.852 332.583 56.3024 332.569 58.8155V231.4C332.569 253.872 323.581 276.793 305.964 299.714C292.481 317.153 273.786 334.681 250.416 351.849C225.444 369.999 198.845 385.797 170.959 399.04L170.509 399.229C169.168 399.769 167.731 400.032 166.285 400.002V400.002ZM165.296 390.834C165.609 390.967 165.945 391.036 166.285 391.036C166.625 391.036 166.961 390.967 167.274 390.834L167.543 390.744C194.766 377.797 220.733 362.36 245.113 344.631C267.763 328.002 285.83 311.013 298.863 294.204C315.312 272.901 323.671 251.777 323.671 231.373V58.7885C323.687 58.2068 323.511 57.636 323.17 57.1647C322.828 56.6933 322.341 56.3478 321.783 56.1818V56.1818L167.004 9.10762C166.541 8.92799 166.028 8.92799 165.566 9.10762L10.8761 56.1998C10.3085 56.3519 9.81071 56.6952 9.46683 57.1717C9.12295 57.6482 8.95401 58.2288 8.98852 58.8155V231.4C8.98852 251.813 17.3477 272.937 33.7964 294.231C46.7396 311.04 64.8062 327.939 87.4569 344.658C111.904 362.456 137.964 377.924 165.296 390.861V390.834Z"
            ></path>
          </svg>
        </div>
        <div
          className="si-plyrSel__club"
          style={{
            backgroundImage: `url(${config.IMG_BASE}clubs/${teamId}.png?v=${ConstraintsData?.data?.PlayerJerseyTeamVersion})`,
          }}
        ></div>
      </div>
    );
  }
}

export default Consume(PlayerImage, [ConstraintsContext]);
